<template lang="pug">
  .component-add-driver-license
    label Document Type
      selectize-document-type(@optionSelected="selectDocType")
    smart-edit(v-if="documentType", :options="options", :value="document", @input="updateFields")

    .attachments(v-if="documentType")
      .upload(v-for="(attachment,index) in documentType.attachment_views")
        label Upload {{attachment}}
        dropzone(:id="'#myVueDropzone'+index", :url='dropzoneUrl', @vdropzone-success='(file, response)=>{uploaded(file,response, attachment)}')

    button.button.expanded(v-on:click="create") Save and Submit

</template>
<script type="text/babel">
  import SmartEdit from 'components/structure/SmartEdit'
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import DatePicker from 'components/structure/DatePicker.vue'
  import BackofficeDriverLicenseCreate from '../../../pages/backoffice/CreateDriverLicense.vue'
  import Dropzone from 'components/structure/Dropzone'
  import SelectizeCountry from '../../structure/ui/lists/selectize/SelectizeCountry'
  import SelectizeDriverLicense from '../../structure/ui/lists/selectize/SelectizeDriverLicense'
  import SelectizeDocumentType from '../../structure/ui/lists/selectize/SelectizeDocumentType'

  export default {
    name: 'DriverLicenseCreate',
    components: {
      SelectizeDocumentType,
      SelectizeDriverLicense,
      SelectizeCountry,
      BackofficeDriverLicenseCreate,
      DatePicker,
      SmartEdit,
      Dropzone
    },
    data() {
      return {
        documentType: null,
        document: {
          driver_id: null,
          document_type_id: null,
          expiry_date: null,
          issuer: null,
          issuer_country: null,
          issue_date: null,
          number: null,
          attachments: {}
        },
        dropzoneUrl: KeplerBackofficeSdk.getUrlForDropzone()
      }
    },
    created() {
      this.document.driver_id = this.item
    },
    methods: {
      selectDocType(obj) {
        this.documentType = obj
        this.document.document_type_id = obj.id
      },
      create() {

        var propNames = Object.getOwnPropertyNames(this.document)
        for (var i = 0; i < propNames.length; i++) {
          var propName = propNames[i]
          if (this.document[propName] === '' || this.document[propName] === null || this.document[propName] === undefined) {
            delete this.document[propName]
          }
        }
        KeplerBackofficeSdk.documents.make(this.document, (data) => {
          location.reload()
        })
      },
      updateFields(item) {
        this.document = item
      },

      selectLicenseCountry(country) {
        this.driverLicense.issuer_country = country.name
      },
      selectLicenseType(driverLicense) {
        this.driverLicense.license_type_id = driverLicense.id
      },
      uploaded: function (file, response, view) {
        this.document.attachments[view] = response.token
      },
    },
    props: [
      'item'
    ],
    computed: {

      options() {
        let options = {
          translations: {},

          types: {
            'expiry_date': 'date',
            'issue_date': 'date',
          },
          disabled: [
            'id',
            'status',
            'created',
          ],

          list: [
            'id',
            'uid',
            'driver_id',
            'driver',
            'attachments',
            'status',
            'type',
            'document_type_id'
          ],
          listMode: 'blacklist',
        }

        const docType = this.documentType
        if (docType) {
          console.log(docType.has_number)
          if (!docType.has_number) {
            options.list.push('number')
          }

          if (!docType.has_expiry) {
            options.list.push('expiry_date')
          }

          if (!docType.has_emission) {
            options.list.push('issue_date')
          }

          if (!docType.has_issuer) {
            options.list.push('issuer')
          }

          if (!docType.has_country) {
            options.list.push('issuer_country')
          }
        }

        return options
      }

    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DriverLicenseCreate.vue?21cfbfb8